export const nativeSelectStyle = {
  appearance: 'none',
  WebkitAppearance: 'none',
  MozAppearance: 'none',
  border: 'var(--border-neutral-thin)',
  borderRadius: 'var(--border-radius-sm)',
  backgroundColor: 'var(--color-surface-050)',
  fontFamily: 'var(--root-font)',
  fontSize: '14px',
  padding: '0 8px',
  height: '50px',
  textAlign: 'center',
  cursor: 'pointer',
  outline: 'none'
}

export const disabledSelectStyle = {
  backgroundColor: 'var(--color-neutral-200)',
  color: 'var(--color-neutral-500)',
  cursor: 'default'
}
